import { isPast, parseISO, setDate } from 'date-fns'
import { TIME_PERIODS } from '../constants'

// Used for U/WAU. Check if date is today.
export const isDateToday = value => {
    try {
        const dateString = value.split(' ')[0] // value comes in format `yyyy-mm-dd hh:mm:ss` and makes error
        const date = new Date(dateString).toLocaleDateString()
        const today = new Date().toLocaleDateString()
        return date === today
    } catch (error) {
        console.log('[smallUtils] isDateToday', { error })
        return false
    }
}

// Used: W. Return date in format `DD/MM/YYYY, hh:mm` or `-`
export const formatDate = (
    value = '',
    options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }
) => {
    try {
        const date = new Date(value)

        return date.toLocaleString('en-GB', options)
    } catch {
        return '-'
    }
}

// Used: W/M. Return date like ['2021','12'], ['2021', 'Q4'] or ['2021']
export const formatChartDate = (currentPeriod = '', value = '') => {
    try {
        const date = new Date(value)

        if (currentPeriod === TIME_PERIODS[2].data) {
            const formattedDate = new Intl.DateTimeFormat('en-GB', { year: 'numeric' }).format(date)
            return formattedDate.split(' ')
        } else {
            const formattedDate = new Intl.DateTimeFormat('en-GB', {
                month: 'short',
                year: '2-digit',
            }).format(date)
            return formattedDate.split(' ')
        }
    } catch {
        return value.split('-')
    }
}

// Used for BudgetSetup
export const findFirstOfMonth = date => setDate(new Date(date), 1).toISOString().split('T')[0]
export const isDateInPast = date => isPast(parseISO(date))
